/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface ServerOAuthAppSpec { 
    /**
     * Choice of client id to be used while creating crdentials. <br> Typical format [service type]-[org id]-[region id]-[SERVER].
     */
    client_id?: string;
    /**
     * Organization Id.
     */
    org_id: string;
    /**
     * Cloud Provider Region ID
     */
    region: string;
    service_type: ServiceTypeEnum;
    /**
     * Time limit for access token in seconds.
     */
    access_token_ttl?: number;
}
export namespace ServerOAuthAppSpec {
}


